<template>
  <div class="navigation-menu">
    <ul class="navbar-nav mr-auto">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="nav-item"
        :class="isActive(item.href) ? 'active' : ''"
        @click="goTo(item.href)"
      >
        <a class="nav-link" href="#">
          {{ item.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NavigationMenu",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goTo(href) {
      if (this.$route.path !== href) window.location.href = href;
    },
    isActive(path) {
      return this.$route.path === path && this.$route.path.includes(path);
    },
  },
};
</script>

<style></style>
